import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SystemStatus } from "@/components/admin/SystemStatus";
import { BackupPanel } from "@/components/admin/BackupPanel";
import { TrashBin } from "@/components/admin/TrashBin";
import { AuditLog } from "@/components/admin/AuditLog";
import { ExportCenter } from "@/components/admin/ExportCenter";
import { DataInfo } from "@/components/admin/DataInfo";

export default function Admin() {
  const { isAdmin, ready } = useAuth();
  if (ready && !isAdmin) return <Navigate to="/" replace />;
  return (
    <div className="space-y-6" data-testid="admin-page">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight">Yönetim</h1>
        <p className="text-sm text-muted-foreground mt-1">Sistem durumu, yedekleme, silinen kayıtlar, işlem geçmişi ve dışa aktarma</p>
      </div>
      <Tabs defaultValue="status">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="status" data-testid="admin-tab-status">Sistem & Yedekleme</TabsTrigger>
          <TabsTrigger value="trash" data-testid="admin-tab-trash">Çöp Kutusu</TabsTrigger>
          <TabsTrigger value="audit" data-testid="admin-tab-audit">İşlem Geçmişi</TabsTrigger>
          <TabsTrigger value="export" data-testid="admin-tab-export">Dışa Aktarma</TabsTrigger>
          <TabsTrigger value="info" data-testid="admin-tab-info">Veri & Yedek Bilgisi</TabsTrigger>
        </TabsList>
        <TabsContent value="status" className="mt-4 space-y-6"><SystemStatus /><BackupPanel /></TabsContent>
        <TabsContent value="trash" className="mt-4"><TrashBin /></TabsContent>
        <TabsContent value="audit" className="mt-4"><AuditLog /></TabsContent>
        <TabsContent value="export" className="mt-4"><ExportCenter /></TabsContent>
        <TabsContent value="info" className="mt-4"><DataInfo /></TabsContent>
      </Tabs>
    </div>
  );
}
